import { CarPark } from "../../../../components/Icons/Setting/CarPark";
import { CarParkBorder } from "../../../../components/Icons/Setting/CarParkBorder";
import { CameraMove } from "../../../../components/Icons/Stream/CameraMove";
import { FaceDetect } from "../../../../components/Icons/Stream/FaceDetect";
import { FireDetect } from "../../../../components/Icons/Stream/FireDetect";
import { LicensePlates } from "../../../../components/Icons/Stream/LicensePlates";
import { MotionDetect } from "../../../../components/Icons/Stream/MotionDetect";
import { ObjectDetect } from "../../../../components/Icons/Stream/ObjectDetect";

export const color_ai = [
    {
        code: "CODE_7",
        color: "#FF0000"
    },
    {
        code: "CODE_10",
        color: "#FF0000"
    },
    {
        code: "CODE_11",
        color: "#FF0000"
    },
    {
        code: "CODE_8",
        color: "#FF0000"
    },
    {
        code: "CODE_9",
        color: "#FF0000"
    },
]


// 'CODE_10', 'ALPR', 'Nhận dạng biển số xe', '20230222000000000006', '1', NULL
// 'CODE_11', 'Fire Detection', 'Cảnh báo cháy', '20230222000000000007', '1', NULL
// 'CODE_6', 'System', 'Hệ thống', NULL, '1', '<SystemIcon />'
// 'CODE_7', 'Motion Detection', 'Phát hiện chuyển động', '20230222000000000001', '1', '<CameraMotion size={0.7} />'
// 'CODE_8', 'Common Object Detection', 'Phát hiện xâm nhập', '20230222000000000004', '1', '<CameraObject size={0.7} />'
// 'CODE_9', 'Camera Movement', 'Phát hiện camera di chuyển', '20230222000000000005', '1', '<CameraMove size={0.7} />'


export const icon_ai = [
    {
        ai_service_code: "20230222000000000006",
        icon: (color) => <LicensePlates color={color} />,
        ai_name: "Nhận dạng biển số xe"
    },
    {
        ai_service_code: "20230222000000000005",
        icon: color => <CameraMove color={color} />,
        ai_name: "Phát hiện camera di chuyển"
    },
    {
        ai_service_code: "20230222000000000007",
        icon: (color) => <FireDetect color={color} />,
        ai_name: "Cảnh báo cháy"
    },
    {
        ai_service_code: "20230222000000000002",
        icon: (color) => <FaceDetect color={color} />,
        ai_name: "Nhận dạng khuôn mặt"
    },
    {
        ai_service_code: "20230222000000000001",
        icon: (color) => <MotionDetect color={color} />,
        ai_name: "Phát hiện chuyển động"
    },
    {
        ai_service_code: "20230222000000000004",
        icon: (color) => <ObjectDetect color={color} />,
        ai_name: "Phát hiện xâm nhập"
    },
    {
        ai_service_code: "20230222000000000008",
        icon: (color) => <CarParkBorder color={color} />,
        ai_name: "Bãi đỗ xe"
    },
]

export const mokeForTurnOnFaceDetect = {
    ai_param_level_code: {
        code: [
            29,
            30
        ]
    },
    ai_service_code: "20230222000000000002",
    time_start: "00:00",
    time_end: "23:59",
    delete_if_off: 0,
    is_zoom: 0,
    is_voice: 0
}